import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwarePoliciesRoute: InvariantJiraRoute = {
	name: 'project-settings-software-policies',
	path: '/jira/software/projects/:projectKey/settings/policies',
	exact: true,
};
